import { useEffect, useState } from 'react';

import { SubmenuNavRef } from '@components/Nav/SubmenuNav';
import {
  ONBOARDING_PRO_NAV_REGISTER_EVENT,
  ONBOARDING_STEP_CHANGE_EVENT,
  ONBOARDING_STEP_IDS,
  onboardingRegistry,
} from '@components/UserOnboardingTooltip/constants';

import useWindowSize from './useWindowSize';

const ONBOARDING_NAV_BREAKPOINT_PX = 1120;

const useUserOnboardingTooltip = () => {
  const { width } = useWindowSize();
  const isMobile = width < ONBOARDING_NAV_BREAKPOINT_PX;

  const [activeStep, setActiveStep] = useState<string | null>(null);
  const [proNavRef, setProNavRef] = useState<SubmenuNavRef | null>(
    onboardingRegistry.proNavRef.current
  );

  useEffect(() => {
    if (isMobile) return;

    const onStepChange = (e: CustomEvent<{ activeStep: string | null }>) =>
      setActiveStep(e.detail.activeStep);

    const onProNavRegister = (e: CustomEvent<{ ref: SubmenuNavRef | null }>) =>
      setProNavRef(e.detail.ref);

    window.addEventListener(ONBOARDING_STEP_CHANGE_EVENT, onStepChange);
    window.addEventListener(ONBOARDING_PRO_NAV_REGISTER_EVENT, onProNavRegister);

    return () => {
      window.removeEventListener(ONBOARDING_STEP_CHANGE_EVENT, onStepChange);
      window.removeEventListener(ONBOARDING_PRO_NAV_REGISTER_EVENT, onProNavRegister);
    };
  }, [isMobile]);

  const isProNavForcedOpen = !isMobile && activeStep === ONBOARDING_STEP_IDS.ProFeatures;
  const isMoreNavForcedOpen = !isMobile && activeStep === ONBOARDING_STEP_IDS.Newsletters;
  const isSettingsNavForcedOpen = !isMobile && activeStep === ONBOARDING_STEP_IDS.Settings;

  return {
    activeStep: isMobile ? null : activeStep,
    proNavRef,
    setActiveStep(step: string | null) {
      if (isMobile) return;
      window.dispatchEvent(
        new CustomEvent(ONBOARDING_STEP_CHANGE_EVENT, { detail: { activeStep: step } })
      );
    },
    isProNavForcedOpen,
    isMoreNavForcedOpen,
    isSettingsNavForcedOpen,
  };
};

export default useUserOnboardingTooltip;
